import type {EditorState, Transaction} from "prosemirror-state";
import {findTablePos} from "../../../utils/findTablePos";
import type {AppState} from "@stores/AppState";

const CSV_DELIMITER = ',';

export const exportTableCsv = (state: EditorState, dispatch?: (tr: Transaction) => void) => {
    const tableNodePos = findTablePos(state);
    if (tableNodePos === undefined) {
        return false;
    }
    const tableNode = state.doc.nodeAt(tableNodePos)!;
    if (dispatch) {
        const data: string[][] = [];
        tableNode.content.forEach(rowNode => {
            const rowData: string[] = [];
            rowNode.content.forEach(cellNode => {
                let cellText = cellNode.textContent;
                if (cellText.includes(CSV_DELIMITER)) {
                    cellText = '"' + cellText.replace(/"/g, '""') + '"';
                }
                rowData.push(cellText);
            });

            data.push(rowData);
        });

        const csvContent = data.map(row => row.join(CSV_DELIMITER)).join('\r\n');

        const appState = state.schema.cached.app.appState as AppState;
        createAndDownloadCSV(csvContent, appState.rootStore.view.workspace?.selected?.name);
    }

    return true;
};

const createAndDownloadCSV = (csvData: string, fileName: string = 'table') => {
    const blob = new Blob([csvData], { type: 'text/csv' });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);

    link.download = `${fileName}.csv`;
    link.dispatchEvent(new MouseEvent('click'));

    URL.revokeObjectURL(url);
}
